export enum IntroFunnelIntents {
  BOOKINGS = 'introFunnel.intents.bookings',
  STORES = 'introFunnel.intents.stores',
}

export interface IntroFunnelState {
  introFunnelIntents?: IntroFunnelIntents[];
}
